/* Hybrid listicle buy box: Buy 1 / Buy 2 / Buy 3 tubes, one flavour per tube (operator
   2026-09-14). Add to cart first puts all of the page's tier codes on the cart, then adds the
   tubes through the Cart API. The codes are hidden, exist for this page only and take a fixed
   amount off each tube once the cart holds 2 or 3 tubes, so every tube in a pack shows the same
   price. Shopify applies the best code for the tube count, so a quantity change in the cart
   drawer re-prices the cart. Codes already on the cart are kept. A coupon typed into the cart
   drawer replaces every code on the cart; the page then puts its codes back (keepCodes).
   The card prices come from Liquid; nothing here rewrites them.
   Monster's cart drawer on this page: its free-shipping bar and Frequently Bought Together come
   from campaign data Monster writes only for the page's product and for products already in the
   cart at page load, so a page with no product lost them (loadCampaigns). Its line prices strike
   the usual price only for automatic discounts or a compare-at price, so the page gives it the
   Single price (mu_handle_compareAt). If the drawer does not open after an add (Monster missing,
   broken or changed by an update), the buyer goes to the cart page (cartIfNoDrawer).
   Takes over from product-funnel.js on this page and keeps its events (pf_product_view,
   pf_variant_change, pf_add_to_cart_success, pf_add_to_cart_error, pf_section_view).
   The form has no /cart/add action: Monster Upsell takes over any such form and would add one
   tube with no code. After the add, monster_refresh() re-reads the cart and opens its drawer.
   Not named hl-*: build.py deletes every hl-* asset that is not a staged image. */
(() => {
  'use strict';
  if (window.HLBundle) return;
  const bound = new WeakSet();
  // One Monster campaign as its product-page snippet writes it: <script>window.mu_campaigns["id"] = {json}</script>,
  // with no semicolon. Liquid's json filter escapes "<", so the first "</script>" ends the object.
  const CAMPAIGN = /window\.mu_campaigns\["([^"]+)"\]\s*=\s*(\{[\s\S]*?\})\s*;?\s*<\/script>/g;
  function init(root) {
    if (bound.has(root)) return;
    bound.add(root);
    const $ = selector => root.querySelector(selector);
    const form = $('[data-hl-bundle]');
    const tiers = [...root.querySelectorAll('[data-hl-tier]')];
    if (!form || !tiers.length) return;
    const variants = JSON.parse($('[data-hl-variants]').textContent);
    const byId = id => variants.find(v => String(v.id) === String(id));
    const add = $('[data-hl-add]');
    const error = $('[data-hl-error]');
    const sticky = $('[data-hl-sticky]');
    const message = $('[data-hl-message]');
    const preview = root.dataset.preview === 'true';
    const fallback = (variants.find(v => v.available) || variants[0] || {}).id;
    const picks = [];
    let busy = false;
    let viewRecorded = false;
    const current = () => tiers.find(t => t.querySelector('[name="hl-tier"]').checked) || tiers[0];
    const pick = i => (byId(picks[i])?.available ? picks[i] : fallback);
    const chosen = () => Array.from({length: Number(current().dataset.hlTier) || 1}, (_, i) => pick(i));
    function emit(event, extra = {}) {
      const ids = chosen();
      const detail = {product_id: root.dataset.productId, product_handle: root.dataset.productHandle, variant_ids: ids, tubes: ids.length, ...extra};
      root.dispatchEvent(new CustomEvent(event, {bubbles: true, detail}));
      if (!preview && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event, ...detail});
      }
    }
    function recordView() {
      if (!viewRecorded && !preview && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
        emit('pf_product_view');
        viewRecorded = true;
      }
    }
    function render() {
      const on = current();
      tiers.forEach(t => {
        t.classList.toggle('is-on', t === on);
        t.querySelector('[data-hl-picks]').hidden = t !== on;
      });
      on.querySelectorAll('[data-hl-pick]').forEach((set, i) => {
        const id = String(pick(i));
        set.querySelectorAll('input').forEach(input => { input.checked = input.value === id; });
        set.querySelector('[data-hl-pick-value]').textContent = byId(id)?.flavour || '';
      });
      const ok = chosen().every(id => byId(id)?.available);
      add.firstChild.textContent = busy ? 'Adding…' : ok ? 'Add to cart' : 'Sold out';
      add.disabled = busy || !ok;
      form.setAttribute('aria-busy', String(busy));
      $('[data-pf-sticky-selection]').textContent = `${on.querySelector('.hl-tier-name b').textContent} · ${on.querySelector('.hl-tier-price b').textContent}`;
    }
    // A page on this store, as a string: an app on the store wraps fetch and fails on URL objects.
    function here(path, base = '/') {
      const url = new URL(path, new URL(base, location.origin));
      if (url.origin !== location.origin) throw new Error('Cart must be on this store.');
      return url.href;
    }
    async function call(path, body, signal) {
      const options = body
        ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body), signal}
        : {headers: {Accept: 'application/json'}, signal};
      const response = await fetch(here(path, root.dataset.cartRoot || '/'), options);
      let result;
      try { result = await response.json(); } catch { throw new Error('The store returned an unexpected response. Check your cart before trying again.'); }
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This pack could not be added. Please try again.');
      return result;
    }
    // All tiers' codes, whatever the tier: Shopify applies the best one for the tube count.
    const codes = tiers.map(t => t.dataset.code).filter(Boolean);
    // Appends the codes the cart lacks. /cart/update.js replaces the whole list, so the ones
    // already there go first. Monster's drawer removes a coupon by sending the code "0"; that is
    // not a code, so it is dropped. wanted() is the list the cart should carry, or null when it
    // already does; addCodes() writes it and returns true when it wrote.
    function wanted(cart) {
      const all = (cart.discount_codes || []).map(d => d.code);
      const have = all.filter(code => code && code !== '0');
      const missing = codes.filter(code => !have.some(h => h.toUpperCase() === code.toUpperCase()));
      return !missing.length && have.length === all.length ? null : [...have, ...missing];
    }
    async function addCodes(cart, signal) {
      const list = wanted(cart);
      if (!list) return false;
      await call('cart/update.js', {discount: list.join(',')}, signal);
      return true;
    }
    // keepCodes: after any cart, discount or checkout request, put the codes back if the cart holds
    // a tube from this box and lost them. The read always runs, so the count resets as soon as the
    // cart is whole again; the write runs at most three times while the codes stay missing (a
    // failed write counts too, or the failed request itself would schedule the next one for ever).
    // A request that lands while a check or an add is in progress is not dropped: it is noted and
    // one more check runs when that work ends, since its read may have seen the cart before the change.
    let cartSettled = () => {};
    function keepCodes() {
      if (preview || !codes.length || !('PerformanceObserver' in window)) return;
      const tubes = new Set(variants.map(v => String(v.id)));
      const watched = /\/cart\/(add|change|update|clear)|discount|\/checkout/i;
      let timer = 0;
      let running = false;
      let pending = false;
      let tries = 0;
      const again = () => { pending = false; clearTimeout(timer); timer = setTimeout(check, 800); };
      cartSettled = () => { if (pending && !running) again(); };
      async function check() {
        if (running || busy) { pending = true; return; }
        running = true;
        pending = false;
        try {
          const cart = await call('cart.js');
          if (!(cart.items || []).some(item => tubes.has(String(item.variant_id)))) return;
          const list = wanted(cart);
          if (!list) { tries = 0; return; }
          if (tries >= 3) return;
          tries += 1;
          await call('cart/update.js', {discount: list.join(',')});
          if (typeof window.monster_refresh === 'function') window.monster_refresh(false);
        } catch {
          // Nothing to show: the next cart request tries again, within the limit above.
        } finally {
          running = false;
          if (pending && !busy) again();
        }
      }
      new PerformanceObserver(list => {
        if (!list.getEntries().some(entry => watched.test(entry.name))) return;
        clearTimeout(timer);
        timer = setTimeout(check, 800);
      }).observe({type: 'resource'});
    }
    // Monster calls this for a line's usual price. For a tube it gets the Single price, so a tube
    // with a code saving shows the usual price struck through. Monster strikes only when the two
    // prices differ, so a full-price tube shows none. Any other line keeps Monster's own sum.
    const prices = new Map(variants.map(v => [String(v.id), v.price]));
    if (!preview && !window.mu_handle_compareAt) {
      window.mu_handle_compareAt = (id, quantity, fallback, compareAt) =>
        !compareAt && prices.has(String(id)) ? prices.get(String(id)) * quantity : compareAt * quantity;
    }
    // Copies Monster's campaigns for this product from its product page, once, unless Monster
    // already wrote them (it always writes the product's collections with them). Monster reads
    // them on its next refresh. Resolves true when it added a campaign and never rejects; a
    // failure tries again on the next call.
    let campaigns = null;
    function loadCampaigns() {
      if (campaigns) return campaigns;
      const id = root.dataset.productId;
      const known = window.mu_products_collections;
      if (preview || !/^\d+$/.test(id || '') || !root.dataset.productUrl || (known && id in known)) return (campaigns = Promise.resolve(false));
      // Monster has not set up yet: nothing is cached, so the next call looks again.
      if (!window.mu_campaigns || !known) return Promise.resolve(false);
      campaigns = Promise.resolve()
        .then(() => fetch(here(root.dataset.productUrl), {headers: {Accept: 'text/html'}}))
        .then(response => { if (response.ok) return response.text(); campaigns = null; return ''; })
        .then(html => {
          const store = window.mu_campaigns;
          let added = false;
          for (const [, key, json] of html.matchAll(CAMPAIGN)) {
            if (store[key]) continue;
            try { store[key] = JSON.parse(json); added = true; } catch { /* Not a campaign: skip it. */ }
          }
          const found = html.match(new RegExp(`window\\.mu_products_collections\\[${id}\\]\\s*=\\s*(\\[[\\d,\\s]*\\])`));
          if (found && !(id in window.mu_products_collections)) window.mu_products_collections[id] = JSON.parse(found[1]);
          return added;
        })
        .catch(() => { campaigns = null; return false; });
      return campaigns;
    }
    // Backup for a drawer that does not open: the buyer goes to the cart page rather than seeing
    // nothing happen. Monster marks its open drawer mu_openned; one that has slid into view also
    // counts, in case an update renames the class.
    function drawerOpen() {
      const drawer = document.getElementById('monster-cart-wrapper');
      if (!drawer) return false;
      const box = drawer.getBoundingClientRect();
      return drawer.classList.contains('mu_openned') || (box.width > 0 && box.left < innerWidth - 1 && box.right > 0);
    }
    function cartIfNoDrawer() {
      const cartPage = here(root.dataset.cartUrl || '/cart');
      if (typeof window.monster_refresh !== 'function') { location.assign(cartPage); return; }
      // The watch starts before the hook runs, so a hook that throws still ends on the cart page
      // instead of turning a completed add into an error message.
      const started = Date.now();
      (function check() {
        if (drawerOpen()) return;
        if (Date.now() - started < 6000) setTimeout(check, 250); else location.assign(cartPage);
      })();
      try { window.monster_refresh(); } catch { /* the watch above sends the buyer to the cart */ }
    }
    form.addEventListener('change', event => {
      const set = event.target.closest('[data-hl-pick]');
      if (set) picks[Number(set.dataset.hlPick)] = event.target.value;
      error.hidden = true;
      render();
      emit('pf_variant_change');
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const ids = chosen();
      if (!ids.every(id => byId(id)?.available)) return;
      error.hidden = true;
      if (preview) {
        $('[data-hl-message-text]').textContent = 'Preview only. Your pack and flavours are selected; checkout is inactive here.';
        message.hidden = false;
        return;
      }
      const counts = new Map();
      ids.forEach(id => counts.set(id, (counts.get(id) || 0) + 1));
      const items = [...counts].map(([id, quantity]) => ({id: Number(id), quantity}));
      busy = true;
      render();
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      const ready = loadCampaigns();
      try {
        await addCodes(await call('cart.js', null, request.signal), request.signal);
        const result = await call('cart/add.js', {items}, request.signal);
        emit('pf_add_to_cart_success', {quantity: ids.length});
        // Let the theme or an app refresh its cart UI without assuming a Dawn version.
        document.dispatchEvent(new CustomEvent('pf:cart-added', {detail: {items: result.items || [result]}}));
        // The campaigns normally arrived while the buyer scrolled. Wait at most 2.5 seconds for
        // them; if they come later, Monster redraws the open drawer without closing it.
        let late = false;
        await Promise.race([ready, new Promise(resolve => setTimeout(() => { late = true; resolve(); }, 2500))]);
        cartIfNoDrawer();
        if (late) ready.then(added => { if (added && typeof window.monster_refresh === 'function') window.monster_refresh(false); }).catch(() => { /* the add is done; the drawer keeps its current view */ });
        const cart = await call('cart.js', null, request.signal).catch(() => null);
        if (cart) document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
      } catch (problem) {
        error.textContent = problem.name === 'AbortError' ? 'The request took too long. Check your cart before trying again.'
          : problem.name === 'TypeError' ? "We couldn't confirm the addition. Check your cart before trying again." : problem.message;
        error.hidden = false;
        emit('pf_add_to_cart_error');
      } finally {
        clearTimeout(timeout);
        busy = false;
        render();
        cartSettled();
      }
    });
    $('[data-hl-sticky-action]').addEventListener('click', () => {
      $('#choose').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      current().querySelector('[name="hl-tier"]').focus({preventScroll: true});
    });
    $('[data-hl-dismiss]').addEventListener('click', () => { message.hidden = true; });
    // The sticky bar shows whenever the buy button is off screen.
    let scheduled = false;
    function place() {
      scheduled = false;
      const rect = add.getBoundingClientRect();
      sticky.hidden = rect.top >= 58 && rect.bottom <= innerHeight;
    }
    const queue = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(place); } };
    addEventListener('scroll', queue, {passive: true});
    addEventListener('resize', queue);
    const seen = new Set();
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting && !seen.has(entry.target.id)) {
        seen.add(entry.target.id);
        emit('pf_section_view', {section: entry.target.id});
      }
    }, {rootMargin: '-65px 0px -55% 0px', threshold: 0});
    document.querySelectorAll('[data-pf-section]').forEach(section => observer.observe(section));
    // Fetch Monster's campaigns only for visitors who come near the buy box.
    new IntersectionObserver((entries, watcher) => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      watcher.disconnect();
      loadCampaigns();
    }, {rootMargin: '800px 0px'}).observe(root);
    document.addEventListener('visitorConsentCollected', recordView);
    render();
    place();
    recordView();
    keepCodes();
  }
  function mount() { document.querySelectorAll('[data-hl-product]').forEach(init); }
  window.HLBundle = {mount};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true}); else mount();
  document.addEventListener('shopify:section:load', mount);
})();